// TODO we have to do kind of shift of coordinates, unexpected so. make sense of it

import { InventoryDimensions } from '../scenes/inventory/coordinates';
import { ScaleWrapperResult } from '../../../htmlOverlay/client/scale/types';

export const inventoryShift = (sw: ScaleWrapperResult) => ({
  top: `${-(sw.transformY(InventoryDimensions.cellSide) / 1.8)}px`,
  left: `${-(sw.transformX(InventoryDimensions.cellSide) / 2)}px`,
});
